export const DEBT_AGE_BAND_KEYS = [
  ...Array.from({ length: 25 }, (_, i) => `month${i}`),
  "moreThan24Months",
] as const;

export type DebtAgeBandKey = (typeof DEBT_AGE_BAND_KEYS)[number];

export function debtAgeBandLabel(key: DebtAgeBandKey) {
  if (key === "moreThan24Months") return "Over 24 Months (GHS)";
  const months = Number(key.replace("month", ""));
  if (months === 0) return "Current Month (GHS)";
  if (months === 1) return "1 Month (GHS)";
  return `${months} Months (GHS)`;
}

export function debtAgeHeaders(keyPrefix = "") {
  return DEBT_AGE_BAND_KEYS.map((key) => ({
    label: debtAgeBandLabel(key),
    key: keyPrefix ? `${keyPrefix}.${key}` : key,
    format: "0,0.00",
  }));
}

export const DEBT_AGING_SUMMARY_HEADERS = [
  { label: "Customers", key: "customers", format: "0,0" },
  { label: "Amount Due (GHS)", key: "amountDue", format: "0,0.00" },
  { label: "Debt Amount (GHS)", key: "debtAmount", format: "0,0.00" },
  ...debtAgeHeaders(),
];

export const DEBT_AGING_SALES_HEADERS = [
  { label: "Amount Due (GHS)", key: "amountDue", format: "0,0.00" },
  { label: "Debt Amount (GHS)", key: "debtAmount", format: "0,0.00" },
  ...debtAgeHeaders("debtAge"),
];
